<template>
    <div class="about-me">
        <v-row>
            <v-col>
                <header class="entry-header">
                    <h1 class="entry-title">about me</h1>
                </header>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <div class="subtitle">
                    <div class="age">
                        <p>{{(new Date().getFullYear()) - 1988}} years</p>
                    </div>
                    <div class="location">
                        <p>USA</p>
                    </div>
                    <div class="current-status"><p>Student</p></div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <div class="description">
                    <p style="text-indent: 25px; " align="justify">
                        Purposeful, full stack web developer with a passion for progressive
                        single page application. My experience made it possible to acquaint
                        myself with most modern technologies for Backend and Frontend.
                    </p>
                </div>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
            <v-col>
                <header class="entry-subheader">
                    <h3 class="entry-subtitle">my stack</h3>
                </header>
            </v-col>
        </v-row>
        <v-row>
            <v-col align="center" justify="center">
                <div class="technology-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <title>Java</title>
                        <g transform="matrix(1.4839512,0,0,1.4824266,66.232979,-0.55062176)" id="java">
                            <path
                                    id="path2"
                                    fill="#303031"
                                    d="m 82.553949,267.47252 c 0,0 -13.198429,7.67535 9.392873,10.27259 27.368728,3.12226 41.356568,2.6745 71.517088,-3.03384 0,0 7.92949,4.97199 19.00358,9.27837 -67.61193,28.97734 -153.019112,-1.67843 -99.913541,-16.51712" />
                            <path
                                    id="path4"
                                    fill="#303031"
                                    d="m 74.292131,229.659 c 0,0 -14.803317,10.95773 7.804742,13.29617 29.236127,3.01615 52.324537,3.26284 92.276367,-4.4302 0,0 5.52587,5.60221 14.21498,8.66584 C 106.84137,271.09469 15.79008,249.0759 74.292131,229.659" />
                            <path
                                    id="path6"
                                    fill="#69696a"
                                    d="m 143.94182,165.5147 c 16.65955,19.18046 -4.37714,36.44044 -4.37714,36.44044 0,0 42.30144,-21.83726 22.8743,-49.18272 -18.14435,-25.50132 -32.05865,-38.17193 43.26772,-81.858558 0,0 -118.237551,29.530298 -61.76488,94.600838" />
                            <path
                                    id="path8"
                                    fill="#303031"
                                    d="m 233.36401,295.44169 c 0,0 9.7671,8.04771 -10.75665,14.27363 -39.0265,11.82254 -162.432466,15.39258 -196.714124,0.47104 -12.323374,-5.36111 10.786444,-12.80094 18.055913,-14.36207 7.581324,-1.64399 11.913775,-1.33771 11.913775,-1.33771 -13.704844,-9.65446 -88.582517,18.95703 -38.034153,27.15089 137.852739,22.35578 251.292389,-10.06685 215.535239,-26.19578" />
                            <path
                                    id="path10"
                                    fill="#303031"
                                    d="m 88.900887,190.47982 c 0,0 -62.772131,14.90944 -22.229178,20.32361 17.118487,2.2919 51.243751,1.77338 83.030571,-0.88995 25.97795,-2.19136 52.06296,-6.85056 52.06296,-6.85056 0,0 -9.16015,3.92285 -15.78729,8.448 -63.744,16.76474 -186.88558636,8.96559 -151.434706,-8.18269 29.980858,-14.49239 54.357643,-12.84841 54.357643,-12.84841" />
                            <path
                                    id="path12"
                                    fill="#303031"
                                    d="m 201.50644,253.42231 c 64.79872,-33.67191 34.83834,-66.03031 13.9264,-61.67086 -5.12558,1.06682 -7.41096,1.99121 -7.41096,1.99121 0,0 1.90277,-2.98077 5.53704,-4.27101 41.37053,-14.54452 73.18714,42.89722 -13.35482,65.64771 0,9.3e-4 1.00259,-0.89554 1.30234,-1.69705" />
                            <path
                                    id="path14"
                                    fill="#69696a"
                                    d="m 162.43898,0.37143273 c 0,0 35.88655,35.89864727 -34.03683,91.10062527 -56.071445,44.281482 -12.78603,69.529602 -0.0233,98.376612 C 95.649047,160.31837 71.629731,134.32273 87.743767,110.12841 111.39538,74.613294 176.91834,57.394269 162.43898,0.37143273" />
                            <path
                                    id="path16"
                                    fill="#303031"
                                    d="m 95.268305,344.66537 c 62.198695,3.98149 157.711825,-2.20905 159.973935,-31.63974 0,0 -4.34828,11.15694 -51.40387,20.01734 -53.08788,9.99051 -118.564304,8.82408 -157.399039,2.42129 9.31e-4,-9.3e-4 7.949963,6.57967 48.828974,9.20111" />
                        </g>
                    </svg>
                </div>
            </v-col>
            <v-col align="center" justify="center">
                <div class="technology-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <title>php</title>
                        <g id="php" transform="matrix(0.92592425,0,0,-0.9282242,-10.666652,406.37232)">
                            <g id="g3472" transform="translate(288,27.3594)">
                                <path
                                        d="M 0,0 C 146.729,0 265.68,60.281 265.68,134.641 265.68,209 146.729,269.282 0,269.282 -146.729,269.282 -265.68,209 -265.68,134.641 -265.68,60.281 -146.729,0 0,0"
                                        id="path3474"
                                        fill="#69696a"/>
                            </g>
                            <g id="g3484" transform="translate(161.7344,145.3066)">
                                <path
                                        d="m 0,0 c 12.065,0 21.072,2.225 26.771,6.611 5.638,4.341 9.532,11.862 11.573,22.353 1.903,9.806 1.178,16.653 -2.154,20.348 C 32.783,53.086 25.417,55 14.297,55 H -4.984 L -15.673,0 Z m -63.063,-67.75 c -0.895,0 -1.745,0.4 -2.314,1.092 -0.57,0.691 -0.801,1.601 -0.63,2.48 L -37.679,81.573 C -37.405,82.982 -36.17,84 -34.734,84 H 26.32 C 45.508,84 59.79,78.79 68.767,68.513 77.792,58.182 80.579,43.741 77.05,25.592 75.614,18.198 73.144,11.331 69.709,5.183 66.27,-0.972 61.725,-6.667 56.198,-11.747 49.582,-17.939 42.094,-22.429 33.962,-25.071 25.959,-27.678 15.681,-29 3.414,-29 h -24.722 l -7.06,-36.322 c -0.274,-1.41 -1.508,-2.428 -2.944,-2.428 z"
                                        id="path3486"
                                        fill="#303031"/>
                            </g>
                            <g id="g3488" transform="translate(159.2236,197.3071)">
                                <path
                                        d="m 0,0 h 16.808 c 13.421,0 18.083,-2.945 19.667,-4.7 2.628,-2.914 3.124,-9.058 1.435,-17.767 C 36.012,-32.217 32.494,-39.13 27.452,-43.012 22.29,-46.986 13.898,-49 2.511,-49 H -9.523 Z m 28.831,35 h -61.055 c -2.872,0 -5.341,-2.036 -5.889,-4.855 l -28.328,-145.751 c -0.342,-1.759 0.12,-3.578 1.259,-4.961 1.14,-1.383 2.838,-2.183 4.63,-2.183 h 31.75 c 2.873,0 5.342,2.036 5.89,4.855 L -16.324,-84 H 5.925 c 12.582,0 23.174,1.372 31.479,4.077 8.541,2.775 16.399,7.48 23.354,13.984 5.752,5.292 10.49,11.232 14.08,17.657 3.591,6.427 6.171,13.594 7.668,21.302 3.715,19.104 0.697,34.402 -8.969,45.466 C 63.965,29.444 48.923,35 28.831,35 M -16.802,-55 H 2.511 c 12.801,0 22.336,2.411 28.601,7.234 6.266,4.824 10.492,12.875 12.688,24.157 2.101,10.832 1.144,18.476 -2.871,22.929 C 36.909,3.773 28.87,6 16.808,6 H -4.946 L -16.802,-55 M 28.831,29 C 47.198,29 60.597,24.18 69.019,14.539 77.44,4.898 79.976,-8.559 76.616,-25.836 75.233,-32.953 72.894,-39.46 69.601,-45.355 66.304,-51.254 61.999,-56.648 56.679,-61.539 50.339,-67.472 43.296,-71.7 35.546,-74.218 27.796,-76.743 17.925,-78 5.925,-78 h -27.196 l -7.531,-38.75 h -31.75 L -32.224,29 h 61.055"
                                        id="path3490"
                                        fill="#888888"/>
                            </g>
                            <g id="g3492" transform="translate(311.583,116.3066)">
                                <path
                                        d="m 0,0 c -0.896,0 -1.745,0.4 -2.314,1.092 -0.571,0.691 -0.802,1.6 -0.631,2.48 L 9.586,68.061 C 10.778,74.194 10.484,78.596 8.759,80.456 7.703,81.593 4.531,83.5 -4.848,83.5 H -27.55 L -43.305,2.428 C -43.579,1.018 -44.814,0 -46.25,0 h -31.5 c -0.896,0 -1.745,0.4 -2.315,1.092 -0.57,0.691 -0.801,1.601 -0.63,2.48 l 28.328,145.751 c 0.274,1.409 1.509,2.427 2.945,2.427 h 31.5 c 0.896,0 1.745,-0.4 2.315,-1.091 0.57,-0.692 0.801,-1.601 0.63,-2.481 L -21.813,113 H 2.609 c 18.605,0 31.221,-3.28 38.569,-10.028 7.49,-6.884 9.827,-17.891 6.947,-32.719 L 34.945,2.428 C 34.671,1.018 33.437,0 32,0 Z"
                                        id="path3494"
                                        fill="#303031"/>
                            </g>
                            <g id="g3496" transform="translate(293.6611,271.0571)">
                                <path
                                        d="m 0,0 h -31.5 c -2.873,0 -5.342,-2.036 -5.89,-4.855 l -28.328,-145.751 c -0.342,-1.759 0.12,-3.578 1.26,-4.961 1.14,-1.383 2.838,-2.183 4.63,-2.183 h 31.5 c 2.872,0 5.342,2.036 5.89,4.855 l 15.283,78.645 h 20.229 c 9.363,0 11.328,-2 11.407,-2.086 0.568,-0.611 1.315,-3.441 0.082,-9.781 l -12.531,-64.489 c -0.342,-1.759 0.12,-3.578 1.26,-4.961 1.14,-1.383 2.838,-2.183 4.63,-2.183 h 32 c 2.872,0 5.342,2.036 5.89,4.855 l 13.179,67.825 c 3.093,15.921 0.447,27.864 -7.861,35.5 -7.928,7.281 -21.208,10.82 -40.599,10.82 H -0.253 L 5.89,-7.145 C 6.231,-5.386 5.77,-3.566 4.63,-2.184 3.49,-0.801 1.792,0 0,0 m 0,-6 -7.531,-38.75 h 28.062 c 17.657,0 29.836,-3.082 36.539,-9.238 6.703,-6.16 8.711,-16.141 6.032,-29.938 l -13.18,-67.824 h -32 l 12.531,64.488 c 1.426,7.336 0.902,12.34 -1.574,15.008 -2.477,2.668 -7.746,4.004 -15.805,4.004 h -25.176 l -16.226,-83.5 h -31.5 L -31.5,-6 H 0"
                                        id="path3498"
                                        fill="#888888"/>
                            </g>
                            <g id="g3500" transform="translate(409.5498,145.3066)">
                                <path
                                        d="m 0,0 c 12.065,0 21.072,2.225 26.771,6.611 5.638,4.34 9.532,11.861 11.574,22.353 1.903,9.806 1.178,16.653 -2.155,20.348 C 32.783,53.086 25.417,55 14.297,55 H -4.984 L -15.673,0 Z m -63.062,-67.75 c -0.895,0 -1.745,0.4 -2.314,1.092 -0.57,0.691 -0.802,1.601 -0.631,2.48 L -37.679,81.573 C -37.404,82.982 -36.17,84 -34.733,84 H 26.32 C 45.509,84 59.79,78.79 68.768,68.513 77.793,58.183 80.579,43.742 77.051,25.592 75.613,18.198 73.144,11.331 69.709,5.183 66.27,-0.972 61.725,-6.667 56.198,-11.747 49.582,-17.939 42.094,-22.429 33.962,-25.071 25.959,-27.678 15.681,-29 3.414,-29 h -24.723 l -7.057,-36.322 c -0.275,-1.41 -1.509,-2.428 -2.946,-2.428 z"
                                        id="path3502"
                                        fill="#303031"/>
                            </g>
                            <g id="g3504" transform="translate(407.0391,197.3071)">
                                <path
                                        d="M 0,0 H 16.808 C 30.229,0 34.891,-2.945 36.475,-4.7 39.104,-7.614 39.6,-13.758 37.91,-22.466 36.012,-32.217 32.493,-39.13 27.452,-43.012 22.29,-46.986 13.898,-49 2.511,-49 H -9.522 Z m 28.831,35 h -61.054 c -2.872,0 -5.341,-2.036 -5.889,-4.855 L -66.44,-115.606 c -0.342,-1.759 0.12,-3.578 1.259,-4.961 1.14,-1.383 2.838,-2.183 4.63,-2.183 h 31.75 c 2.872,0 5.342,2.036 5.89,4.855 L -16.324,-84 H 5.925 c 12.582,0 23.174,1.372 31.479,4.077 8.541,2.775 16.401,7.481 23.356,13.986 5.752,5.291 10.488,11.23 14.078,17.655 3.591,6.427 6.171,13.594 7.668,21.302 3.715,19.105 0.697,34.403 -8.969,45.467 C 63.965,29.444 48.924,35 28.831,35 M -16.801,-55 H 2.511 c 12.801,0 22.336,2.411 28.601,7.234 6.267,4.824 10.492,12.875 12.688,24.157 2.102,10.832 1.145,18.476 -2.871,22.929 C 36.909,3.773 28.87,6 16.808,6 H -4.946 L -16.801,-55 M 28.831,29 C 47.198,29 60.597,24.18 69.019,14.539 77.441,4.898 79.976,-8.559 76.616,-25.836 75.233,-32.953 72.894,-39.46 69.601,-45.355 66.304,-51.254 61.999,-56.648 56.679,-61.539 50.339,-67.472 43.296,-71.7 35.546,-74.218 27.796,-76.743 17.925,-78 5.925,-78 h -27.196 l -7.53,-38.75 h -31.75 L -32.223,29 h 61.054"
                                        id="path3506"
                                        fill="#888888"/>
                            </g>
                        </g>
                    </svg>
                </div>
            </v-col>
            <v-col align="center" justify="center">
                <div class="technology-icon" style="margin-top: -10px;">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <title>MySQL</title>
                        <g transform="matrix(2.913113,0,0,2.9149471,-24.743982,-8.4093135)" fill-rule="evenodd" id="mysql">
                            <path
                                    d="m 8.504,128.215 h 5.8 v -22.977 l 9.058,20.033 c 1.026,2.408 2.5,3.3 5.354,3.3 2.854,0 4.24,-0.893 5.3,-3.3 l 9.013,-20.033 v 22.977 h 5.845 v -22.977 c 0,-2.23 -0.893,-3.303 -2.767,-3.883 -4.417,-1.338 -7.362,-0.178 -8.7,2.81 l -8.878,19.81 -8.567,-19.81 c -1.294,-2.988 -4.284,-4.148 -8.745,-2.81 -1.83,0.58 -2.722,1.652 -2.722,3.883 l -10e-4,22.977 z m 45.198,-18.694 h 5.845 v 12.627 c -0.044,0.713 0.223,2.32 3.4,2.363 1.65,0.045 12.582,0 12.67,0 v -15.08 h 5.845 v 20.658 c 0,5.086 -6.3,6.2 -9.236,6.246 h -18.38 v -3.88 h 18.427 c 3.748,-0.402 3.302,-2.275 3.302,-2.9 v -1.518 h -12.36 c -5.756,-0.045 -9.46,-2.588 -9.503,-5.488 v -13.03 z M 179.076,94.886 c -3.568,-0.09 -6.336,0.268 -8.656,1.25 -0.668,0.27 -1.74,0.27 -1.828,1.116 0.357,0.355 0.4,0.936 0.713,1.428 0.535,0.893 1.473,2.096 2.32,2.72 0.938,0.715 1.875,1.428 2.855,2.053 1.74,1.07 3.703,1.695 5.398,2.766 0.982,0.625 1.963,1.428 2.945,2.098 0.5,0.357 0.803,0.938 1.428,1.16 v -0.135 c -0.312,-0.4 -0.402,-0.98 -0.713,-1.428 -0.447,-0.445 -0.893,-0.848 -1.34,-1.293 -1.293,-1.74 -2.9,-3.258 -4.64,-4.506 -1.428,-0.982 -4.55,-2.32 -5.13,-3.97 l -0.088,-0.09 c 0.98,-0.09 2.14,-0.447 3.078,-0.715 1.518,-0.4 2.9,-0.312 4.46,-0.713 0.715,-0.18 1.428,-0.402 2.143,-0.625 v -0.4 c -0.803,-0.803 -1.383,-1.874 -2.23,-2.632 -2.275,-1.963 -4.775,-3.882 -7.363,-5.488 -1.383,-0.892 -3.168,-1.473 -4.64,-2.23 -0.537,-0.268 -1.428,-0.402 -1.74,-0.848 -0.805,-0.98 -1.25,-2.275 -1.83,-3.436 -1.293,-2.454 -2.543,-5.175 -3.658,-7.763 -0.803,-1.74 -1.295,-3.48 -2.275,-5.086 -4.596,-7.585 -9.594,-12.18 -17.268,-16.687 -1.65,-0.937 -3.613,-1.34 -5.7,-1.83 l -3.346,-0.18 c -0.715,-0.312 -1.428,-1.16 -2.053,-1.562 -2.543,-1.606 -9.102,-5.086 -10.977,-0.49 -1.205,2.9 1.785,5.755 2.8,7.228 0.76,1.026 1.74,2.186 2.277,3.346 0.3,0.758 0.4,1.562 0.713,2.365 0.713,1.963 1.383,4.15 2.32,5.98 0.5,0.937 1.025,1.92 1.65,2.767 0.357,0.49 0.982,0.714 1.115,1.517 -0.625,0.893 -0.668,2.23 -1.025,3.347 -1.607,5.042 -0.982,11.288 1.293,14.99 0.715,1.115 2.4,3.57 4.686,2.632 2.008,-0.803 1.56,-3.346 2.14,-5.577 0.135,-0.535 0.045,-0.892 0.312,-1.25 v 0.09 l 1.83,3.703 c 1.383,2.186 3.793,4.462 5.8,5.98 1.07,0.803 1.918,2.187 3.256,2.677 V 97.03 h -0.088 c -0.268,-0.4 -0.67,-0.58 -1.027,-0.892 -0.803,-0.803 -1.695,-1.785 -2.32,-2.677 -1.873,-2.498 -3.523,-5.265 -4.996,-8.12 -0.715,-1.383 -1.34,-2.9 -1.918,-4.283 -0.27,-0.536 -0.27,-1.34 -0.715,-1.606 -0.67,0.98 -1.65,1.83 -2.143,3.034 -0.848,1.918 -0.936,4.283 -1.248,6.737 -0.18,0.045 -0.1,0 -0.18,0.09 -1.426,-0.356 -1.918,-1.83 -2.453,-3.078 -1.338,-3.168 -1.562,-8.254 -0.402,-11.913 0.312,-0.937 1.652,-3.882 1.117,-4.774 -0.27,-0.848 -1.16,-1.338 -1.652,-2.008 -0.58,-0.848 -1.203,-1.918 -1.605,-2.855 -1.07,-2.5 -1.605,-5.265 -2.766,-7.764 -0.537,-1.16 -1.473,-2.365 -2.232,-3.435 -0.848,-1.205 -1.783,-2.053 -2.453,-3.48 -0.223,-0.49 -0.535,-1.294 -0.178,-1.83 0.088,-0.357 0.268,-0.49 0.623,-0.58 0.58,-0.49 2.232,0.134 2.812,0.4 1.65,0.67 3.033,1.294 4.416,2.23 0.625,0.446 1.295,1.294 2.098,1.518 h 0.938 c 1.428,0.312 3.033,0.09 4.37,0.49 2.365,0.76 4.506,1.874 6.426,3.08 5.844,3.703 10.664,8.968 13.92,15.26 0.535,1.026 0.758,1.963 1.25,3.034 0.938,2.187 2.098,4.417 3.033,6.56 0.938,2.097 1.83,4.24 3.168,5.98 0.67,0.937 3.346,1.427 4.55,1.918 0.893,0.4 2.275,0.76 3.08,1.25 1.516,0.937 3.033,2.008 4.46,3.034 0.713,0.534 2.945,1.65 3.078,2.54 z m -45.5,-38.772 a 7.09,7.09 0 0 0 -1.828,0.223 v 0.09 h 0.088 c 0.357,0.714 0.982,1.205 1.428,1.83 l 1.027,2.142 0.088,-0.09 c 0.625,-0.446 0.938,-1.16 0.938,-2.23 -0.268,-0.312 -0.312,-0.625 -0.535,-0.937 -0.268,-0.446 -0.848,-0.67 -1.206,-1.026 z"
                                    fill="#303031"
                                    id="path1222" />
                            <path
                                    d="m 85.916,128.215 h 16.776 c 1.963,0 3.838,-0.4 5.354,-1.115 2.543,-1.16 3.748,-2.72 3.748,-4.773 v -4.283 c 0,-1.65 -1.383,-3.213 -4.148,-4.283 -1.428,-0.535 -3.213,-0.848 -4.953,-0.848 h -7.05 c -2.365,0 -3.48,-0.715 -3.793,-2.275 -0.044,-0.178 -0.044,-0.357 -0.044,-0.535 v -2.633 c 0,-0.135 0,-0.312 0.044,-0.49 0.312,-1.205 0.937,-1.518 3,-1.74 h 17.177 v -3.883 h -16.33 c -2.365,0 -3.614,0.135 -4.73,0.492 -3.436,1.07 -4.953,2.766 -4.953,5.754 v 3.393 c 0,2.63 2.945,4.863 7.942,5.398 0.535,0.045 1.115,0.045 1.695,0.045 h 6.024 c 0.223,0 0.445,0 0.623,0.045 1.83,0.178 2.633,0.49 3.168,1.158 0.357,0.357 0.447,0.67 0.447,1.072 v 3.39 c 0,0.4 -0.268,0.938 -0.803,1.383 -0.535,0.445 -1.385,0.758 -2.5,0.803 -0.223,0 -0.355,0.045 -0.58,0.045 H 85.916 Z m 62.195,-6.736 c 0,3.97 3,6.2 8.97,6.648 0.58,0.045 1.115,0.088 1.695,0.088 h 15.17 v -3.88 h -15.303 c -3.393,0 -4.686,-0.848 -4.686,-2.9 V 101.357 H 148.1 v 20.123 z m -32.615,0.177 v -13.83 c 0,-3.525 2.498,-5.668 7.363,-6.336 0.535,-0.045 1.07,-0.09 1.56,-0.09 h 11.064 c 0.58,0 1.072,0.045 1.652,0.09 4.863,0.668 7.316,2.81 7.316,6.336 v 13.83 c 0,2.855 -1.025,4.373 -3.436,5.4 l 5.71,5.174 h -6.736 l -4.64,-4.193 -4.686,0.268 h -6.246 a 13.66,13.66 0 0 1 -3.391,-0.445 c -3.7,-1.028 -5.53,-2.99 -5.53,-6.204 z m 6.29,-0.31 c 0,0.178 0.1,0.355 0.135,0.58 0.312,1.605 1.828,2.498 4.148,2.498 h 5.266 l -4.818,-4.373 h 6.736 l 4.238,3.838 c 0.805,-0.447 1.295,-1.072 1.473,-1.875 0.045,-0.178 0.045,-0.4 0.045,-0.58 v -13.252 c 0,-0.178 0,-0.355 -0.045,-0.535 -0.312,-1.516 -1.828,-2.363 -4.104,-2.363 h -8.79 c -2.588,0 -4.283,1.115 -4.283,2.898 z"
                                    fill="#69696a"
                                    id="path1224" />
                        </g>
                    </svg>
                </div>
            </v-col>
            <v-col align="center" justify="center">
                <div class="technology-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <title>HTML5</title>
                        <g id="html">
                            <path
                                    d="M 74.632812 100.61914 L 107.64453 470.87695 L 255.77734 512 L 404.32031 470.81836 L 437.36719 100.61914 L 74.632812 100.61914 z M 142.13281 176.30469 L 255.84375 176.30469 L 256 176.30469 L 256 176.30664 L 369.75391 176.30664 L 368.66797 188.48828 L 366.59961 211.50977 L 365.6875 221.7168 L 365.54297 221.7168 L 256 221.7168 L 191.75977 221.7168 L 195.91016 268.2168 L 255.84375 268.2168 L 256 268.2168 L 349.16211 268.2168 L 361.40039 268.2168 L 360.29102 280.41016 L 349.62109 399.96289 L 348.9375 407.63477 L 256 433.39258 L 256 433.39844 L 255.79102 433.45703 L 162.77148 407.63477 L 156.4082 336.33203 L 177.41992 336.33203 L 201.99414 336.33203 L 205.22656 372.55078 L 255.80078 386.20508 L 255.84375 386.19336 L 255.84375 386.19141 L 306.49023 372.52148 L 311.76172 313.62695 L 256 313.62695 L 255.84375 313.62695 L 154.38086 313.62695 L 143.21875 188.48828 L 142.13281 176.30469 z "
                                    fill="#303031"
                                    id="polygon4" />
                            <path
                                    d="M 256 130.89453 L 256 176.30469 L 369.59766 176.30469 L 368.51172 188.48828 L 366.44141 211.50977 L 365.53125 221.7168 L 365.38477 221.7168 L 256 221.7168 L 256 268.2168 L 349.16211 268.2168 L 361.39844 268.2168 L 360.29102 280.41016 L 349.61914 399.96289 L 348.9375 407.63477 L 256 433.39258 L 256 480.52344 L 376.0293 447.24609 L 404.26953 130.89453 L 256 130.89453 z M 256 313.62695 L 256 386.14844 L 306.49023 372.52148 L 311.76172 313.62695 L 256 313.62695 z "
                                    fill="#69696a"
                                    id="polygon6" />
                            <path
                                    fill="#888888"
                                    id="path12"
                                    d="M108.382,0h23.077v22.8h21.11V0h23.078v69.044H152.57v-23.12h-21.11v23.12h-23.077V0z" />
                            <path
                                    fill="#888888"
                                    id="path14"
                                    d="M205.994,22.896h-20.316V0h63.72v22.896h-20.325v46.148h-23.078V22.896z" />
                            <path
                                    fill="#888888"
                                    id="path16"
                                    d="M259.511,0h24.063l14.802,24.26L313.163,0h24.072v69.044h-22.982V34.822l-15.877,24.549h-0.397l-15.888-24.549v34.222h-22.58V0z" />
                            <path
                                    fill="#888888"
                                    id="path18"
                                    d="M348.72,0h23.084v46.222h32.453v22.822H348.72V0z" />
                        </g>
                    </svg>
                </div>
            </v-col>
            <v-col align="center" justify="center">
                <div class="technology-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <title>CSS3</title>
                        <g id="css">
                            <path
                                    d="M 74.632812 100.61914 L 107.64453 470.87695 L 255.77734 512 L 404.32031 470.81836 L 437.36719 100.61914 L 74.632812 100.61914 z M 142.13281 176.30469 L 255.84375 176.30469 L 256 176.30469 L 369.59766 176.30469 L 361.40039 268.2168 L 360.29297 280.41016 L 349.62109 399.96094 L 348.9375 407.63281 L 256 433.39062 L 256 433.39844 L 255.79102 433.45703 L 162.77148 407.63281 L 156.41016 336.33203 L 177.41992 336.33203 L 201.99414 336.33203 L 205.22656 372.54883 L 255.80078 386.20508 L 255.84375 386.19336 L 255.84375 386.18945 L 306.49023 372.51953 L 311.76172 313.625 L 256 313.625 L 256 313.62695 L 154.38086 313.62695 L 150.31055 268.2168 L 255.84375 268.2168 L 256 268.2168 L 315.69922 268.2168 L 319.83203 221.71484 L 256 221.71484 L 255.84375 221.71484 L 146.25977 221.71484 L 142.13281 176.30469 z "
                                    fill="#303031"
                                    id="polygon2989" />
                            <path
                                    d="M 256 130.89258 L 256 176.30469 L 369.59766 176.30469 L 361.39844 268.2168 L 360.29102 280.41016 L 349.62109 399.96094 L 348.9375 407.63281 L 256 433.39062 L 256 480.52148 L 376.0293 447.24609 L 404.26953 130.89258 L 256 130.89258 z M 256 221.71484 L 256 268.2168 L 315.69922 268.2168 L 319.83203 221.71484 L 256 221.71484 z M 256 313.62695 L 256 386.14648 L 306.49023 372.51953 L 311.76172 313.62695 L 256 313.62695 z "
                                    fill="#69696a"
                                    id="polygon2991" />
                            <path
                                    fill="#888888"
                                    id="path2999"
                                    d="m 160.00019,-8.6e-4 h 55 v 23 h -32 v 23 h 32 v 23 h -55 z"/>
                            <path
                                    fill="#888888"
                                    id="path3001"
                                    d="m 226.00019,-8.6e-4 h 55 v 20 h -32 v 4 h 32 v 46 h -55 v -21 h 32 v -4 h -32 z"/>
                            <path
                                    fill="#888888"
                                    id="path3003"
                                    d="m 292.00019,-8.6e-4 h 55 v 20 h -32 v 4 h 32 v 46 h -55 v -21 h 32 v -4 h -32 z"/>
                        </g>
                    </svg>
                </div>
            </v-col>
            <v-col align="center" justify="center">
                <div class="technology-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <title>JavaScript</title>
                        <g id="javascript">
                            <path
                                    d="M 74.732422 100.36328 L 108.33203 470.24023 L 255.43555 511.74414 L 403.38477 469.95703 L 436.70312 100.50391 L 74.732422 100.36328 z M 256 133.25781 L 404.23242 133.25781 L 376.13867 450.05078 L 257.12891 482.66211 L 256 133.25781 z M 206.16602 179.70312 L 242.16406 179.70312 L 242.16406 179.84375 L 242.16406 422.24023 L 136.00195 393.58203 L 135.86133 350.24219 L 205.74219 369.30078 L 206.16602 179.84375 L 206.16602 179.70312 z "
                                    fill="#303031"
                                    id="path5113" />
                            <path
                                    fill="#69696a"
                                    d="M 256,133.11585 H 404.23269 L 376.13907,449.91029 256,482.52148 Z m 112.51567,263.71302 9.74101,-118.44498 -71.99874,8.04692 v -63.24595 l 76.79865,-0.28235 3.10583,-43.19924 -115.90385,0.5647 1.55292,157.26782 70.0223,-11.99979 -0.98822,35.01115 -70.587,18.77614 0.70587,42.9169 z"
                                    id="path5117" />
                            <path
                                    fill="#888888"
                                    id="path3001"
                                    d="m 226,0 23.00019,-8.6e-4 v 70 h -55 v -21 h 32 C 226,0 225.72988,49 226,0 Z"/>
                            <path
                                    fill="#888888"
                                    id="path3003"
                                    d="m 260.00019,-8.6e-4 h 55 v 20 h -32 v 4 h 32 v 46 h -55 v -21 h 32 v -4 h -32 z"/>
                        </g>
                    </svg>
                </div>
            </v-col>
            <v-col align="center" justify="center">
                <div class="technology-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <title>Vue.js</title>
                        <g transform="matrix(2.607987,0,0,-2.6114575,-149.2577,647.71863)" id="vue">
                            <g transform="translate(178.06,235.01)" id="g1178">
                                <path
                                        d="M 0,0 -22.669,-39.264 -45.338,0 h -75.491 L -22.669,-170.02 75.491,0 Z"
                                        fill="#69696a"
                                        id="path1176" />
                            </g>
                            <g transform="translate(178.06,235.01)" id="g1182">
                                <path
                                        d="M 0,0 -22.669,-39.264 -45.338,0 H -81.565 L -22.669,-102.01 36.227,0 Z"
                                        fill="#303031"
                                        id="path1180" />
                            </g>
                        </g>
                    </svg>
                </div>
            </v-col>
            <v-col align="center" justify="center">
                <div class="technology-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <title>Vuetify</title>
                        <g transform="matrix(0.2048,0,0,0.2048,32,0)" id="vuetify">
                            <path
                                    d="m 1093.8,0 h -511 l 511,1208"
                                    fill="#303031"
                                    id="path1203" />
                            <path
                                    d="M 1093.8,1562.5 V 2500 L 0,364.5 H 573 Z M 1093.8,0 h 511 l -511,1208"
                                    fill="#69696a"
                                    id="path1205" />
                            <path
                                    d="m 1614.5,364.5 h 573 L 1093.8,2500 v -937.5 z"
                                    fill="#888888"
                                    id="path1207" />
                        </g>
                    </svg>
                </div>
            </v-col>
        </v-row>
        <v-row style="margin-top: 20px;">
            <v-col>
                <div class="description">
                    <p style="text-indent: 25px;" align="justify">
                        Additionally, I am familiar with
                        <span style="color: #e65100">Python</span> and
                        <span style="color: #e65100">C++</span>. I worked with
                        <span style="color: #e65100">VB Application</span>
                        for importing data to MS Excel and MS Word. As Frontend I have an experience with
                        <span style="color: #e65100">JQuery</span>,
                        <span style="color: #e65100">Ajax</span>(fetch, axios),
                        <span style="color: #e65100">Bootstrap</span>.
                    </p>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <div class="description">
                    <p style="text-indent: 25px;">
                        For more information about my career and education press
                        <v-btn class="ma-2" tile outlined x-small color="#e65100" @click="openPage('/skills')">Skills</v-btn>
                    </p>
                </div>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
            <v-col>
                <header class="entry-subheader">
                    <h3 class="entry-subtitle">my projects</h3>
                </header>
            </v-col>
        </v-row>
        <v-row>
            <v-col align="center" justify="center">
                <div class="project">
                    <div>
                        <div id="elegant-project" class="project-icon" @click="openPage('/elegant-crm')">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 135.46667 135.46667">
                                <g id="layer1" transform="translate(133.50119,20.10833)" style="display:inline">
                                    <circle
                                            cy="47.625"
                                            cx="-65.767868"
                                            id="path839"
                                            style="fill-opacity:1;stroke-width:0.236542"
                                            fill="#121212"
                                            r="67.46875" />
                                    <path
                                            id="path833"
                                            fill="#ffffff"
                                            style="fill-opacity:1;stroke-width:0.364723"
                                            d="M -65.76786,-20.10833 A 67.73333,67.73333 0 0 0 -133.50119,47.625004 67.73333,67.73333 0 0 0 -65.76786,115.35834 67.73333,67.73333 0 0 0 1.96547,47.625004 67.73333,67.73333 0 0 0 -65.76786,-20.10833 Z m 0,6.614583 a 61.118747,61.118747 0 0 1 61.11875,61.118751 61.118747,61.118747 0 0 1 -61.11875,61.118746 61.118747,61.118747 0 0 1 -61.11875,-61.118746 61.118747,61.118747 0 0 1 61.11875,-61.118751 z" />
                                    <path
                                            fill="#69696a"
                                            style="display:inline;opacity:1;fill-opacity:1;stroke:none;stroke-width:0.202328px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                                            d="M -65.767857,88.666547 -17.411363,60.542895 V 34.240199 L -65.3632,6.3188758 -114.12435,34.644856 v 25.898039 z"
                                            id="path930"/>
                                    <path
                                            fill="#121212"
                                            style="fill-opacity:1;stroke:none;stroke-width:0.202328px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                                            d="m -109.4708,35.251841 43.500614,-25.2910535 43.500613,25.2910535 -10.925734,6.272182 -29.74228,-17.400245 -2.63027,1.618627 29.539952,17.400245 -13.556006,8.295466 -30.146936,-17.400245 -2.832596,1.4163 30.146935,17.400244 -13.353678,7.68848 z"
                                            id="path851"/>
                                    <path
                                            id="rect879"
                                            fill="#121212"
                                            style="fill-opacity:1;stroke:none;stroke-width:0.237078;stroke-opacity:1"
                                            d="m -36.227905,43.14265 2.832598,-1.618627 v 28.32598 l -2.832598,1.618628 z"/>
                                    <path
                                            d="m -52.616508,52.854415 2.832598,-1.416299 v 27.921326 l -2.832593,1.618627 z"
                                            fill="#121212"
                                            style="fill-opacity:1;stroke:none;stroke-width:0.237078;stroke-opacity:1"
                                            id="path927" />
                                </g>
                            </svg>
                        </div>
                        <div class="project-title"><h4>elegant-crm</h4></div>
                    </div>
                    <v-divider></v-divider>
                    <div class="project-description">
                        <p>Full stack enterprise crm progressive web application</p>
                    </div>
                </div>
            </v-col>
            <v-col align="center" justify="center">
                <div class="project">
                    <div>
                        <div id="pet-project" class="project-icon" @click="openPage('/demo-of-algorithms')">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384.00001 384.00002">
                                <circle
                                        r="191.25"
                                        style="fill-opacity:1;stroke-width:0.670513"
                                        fill="#121212"
                                        id="path839"
                                        cx="192"
                                        cy="192" />
                                <g
                                        transform="matrix(0.02167951,0,0,-0.02168621,53.26323,311.275)"
                                        fill="#69696a"
                                        stroke="none"
                                        id="g8">
                                    <path
                                            style="fill-opacity:1"
                                            d="m 3165,10985 c -247,-44 -306,-193 -276,-688 12,-185 11,-200 -6,-234 -27,-55 -57,-71 -183,-97 -96,-20 -151,-39 -315,-114 -110,-50 -227,-100 -260,-111 l -60,-21 -66,73 c -36,39 -104,115 -151,167 -175,197 -297,281 -420,288 -59,4 -75,1 -130,-26 -35,-16 -89,-52 -120,-78 -96,-81 -342,-358 -379,-427 -31,-56 -34,-70 -34,-142 0,-68 5,-88 29,-135 44,-85 111,-163 289,-337 l 165,-161 -33,-49 c -106,-158 -215,-392 -286,-612 -23,-73 -52,-145 -65,-160 l -22,-26 H 553 C 224,8094 196,8089 116,8019 24,7938 0,7843 0,7568 c 1,-280 20,-383 89,-474 45,-61 131,-106 230,-123 40,-6 181,-11 328,-11 h 259 l 23,-72 c 66,-214 196,-491 282,-603 60,-79 71,-101 64,-128 -4,-12 -109,-123 -234,-247 -253,-251 -289,-300 -298,-398 -3,-33 -3,-76 1,-96 22,-117 375,-491 551,-584 72,-38 168,-37 247,2 79,40 167,117 291,254 59,64 151,164 205,222 l 99,104 99,-46 c 198,-93 344,-146 548,-199 137,-35 129,-16 116,-269 -13,-281 -13,-516 1,-582 21,-100 70,-173 141,-209 84,-43 161,-53 383,-52 400,1 497,35 572,200 55,120 63,251 37,626 -20,281 -26,263 105,302 165,49 317,107 474,183 86,41 158,73 160,71 23,-32 363,-401 413,-450 130,-123 219,-169 329,-169 118,0 178,39 419,271 250,240 301,363 218,525 -46,90 -133,184 -335,362 -102,90 -188,170 -191,179 -12,31 -4,70 25,123 144,255 186,344 246,515 60,173 75,181 323,176 394,-9 462,-7 515,12 103,35 164,117 185,247 18,112 24,385 11,499 -24,204 -67,284 -179,334 -96,43 -213,53 -464,39 -199,-11 -235,-10 -290,13 -30,12 -55,67 -82,178 -22,91 -42,140 -125,300 -107,209 -133,285 -111,336 6,16 69,82 138,146 162,148 262,261 304,344 29,58 33,75 33,147 0,72 -4,87 -37,156 -31,61 -67,107 -193,242 -223,238 -292,285 -416,286 -57,0 -77,-5 -139,-37 -77,-38 -184,-137 -415,-385 -141,-151 -131,-150 -375,-15 -36,19 -135,57 -220,82 -179,54 -264,91 -302,129 -33,34 -35,45 -27,171 12,184 9,416 -5,487 -31,142 -103,237 -213,278 -94,35 -507,51 -648,25 z m 461,-2480 c 425,-72 715,-337 793,-722 72,-354 -44,-702 -305,-912 -399,-321 -1062,-299 -1427,47 -177,169 -267,390 -268,656 0,138 13,226 51,334 93,271 325,481 627,567 49,14 115,29 148,34 98,14 286,12 381,-4 z"
                                            id="path4" />
                                    <path
                                            style="fill-opacity:1"
                                            d="m 8765,7710 c -126,-6 -217,-25 -278,-57 -49,-25 -108,-85 -134,-136 -50,-99 -57,-165 -58,-496 v -304 l -104,-24 c -220,-50 -443,-135 -660,-250 -145,-76 -172,-86 -209,-72 -15,6 -115,99 -222,209 -215,219 -281,269 -381,290 -55,12 -71,12 -127,-3 -97,-26 -184,-90 -357,-265 -175,-177 -224,-239 -269,-332 -27,-56 -31,-76 -31,-146 0,-74 4,-88 38,-156 46,-91 139,-197 348,-397 l 155,-149 -71,-144 c -112,-226 -195,-473 -220,-656 -12,-85 -17,-100 -42,-121 l -28,-24 -295,6 c -306,7 -424,0 -514,-29 -186,-61 -232,-182 -230,-609 0,-206 3,-254 22,-339 33,-153 87,-219 223,-268 63,-23 70,-23 359,-19 162,3 355,5 429,5 l 134,1 28,-83 c 65,-194 151,-379 273,-591 37,-64 66,-127 66,-142 0,-21 -13,-38 -52,-70 -81,-66 -393,-361 -479,-451 -92,-97 -133,-162 -154,-246 -27,-106 3,-196 113,-333 102,-128 395,-394 482,-439 124,-63 255,-43 410,63 77,53 196,175 382,390 149,172 185,207 207,207 14,0 121,-47 236,-104 193,-96 382,-171 528,-212 50,-13 56,-18 53,-37 -11,-52 -29,-605 -23,-708 9,-171 45,-273 123,-353 81,-83 161,-101 489,-112 392,-12 547,35 618,189 56,121 64,234 42,596 -19,314 -18,326 40,354 19,9 72,26 117,37 183,46 382,119 558,205 183,88 236,64 485,-225 208,-241 296,-308 421,-318 85,-6 141,15 249,95 129,96 368,339 437,443 75,115 92,163 86,244 -11,134 -113,266 -395,514 -81,71 -149,139 -162,163 -34,60 -25,110 37,212 80,132 99,176 152,355 54,185 87,268 126,319 46,61 58,63 285,54 388,-16 550,17 656,132 89,97 102,148 115,479 10,239 10,276 -6,354 -35,180 -102,251 -277,296 -80,20 -97,20 -339,13 -374,-12 -400,-12 -437,8 -43,23 -64,67 -102,212 -26,100 -45,145 -117,278 -108,197 -143,285 -144,355 0,62 -2,60 204,243 173,154 264,259 319,368 40,81 42,89 42,175 0,81 -3,97 -30,150 -34,67 -141,192 -320,372 -177,178 -259,226 -384,226 -141,-1 -287,-110 -551,-412 -135,-155 -167,-180 -229,-180 -48,0 -70,10 -189,88 -84,55 -144,81 -432,187 -69,25 -152,60 -185,78 l -60,32 v 55 c 0,30 6,145 13,254 23,334 -8,507 -106,609 -99,103 -231,121 -697,97 z m 359,-2704 c 55,-14 148,-50 210,-79 540,-262 839,-851 686,-1352 -81,-267 -302,-521 -563,-649 -152,-74 -233,-91 -427,-90 -150,1 -173,3 -255,28 -192,58 -351,144 -487,265 -283,251 -438,566 -438,891 0,259 104,498 306,705 151,155 344,261 549,301 107,20 297,12 419,-20 z"
                                            id="path6" />
                                </g>
                                <path
                                        d="M 192,0 A 192,192 0 0 0 0,192.00001 192,192 0 0 0 192,384.00002 192,192 0 0 0 384.00001,192.00001 192,192 0 0 0 192,0 Z m 0,18.750001 A 173.25,173.25 0 0 1 365.25001,192.00001 173.25,173.25 0 0 1 192,365.25001 173.25,173.25 0 0 1 18.750001,192.00001 173.25,173.25 0 0 1 192,18.750001 Z"
                                        fill="#ffffff"
                                        style="fill-opacity:1;stroke-width:1.03386"
                                        id="path833" />
                            </svg>
                        </div>
                        <div class="project-title"><h4>Demo of algorithms</h4></div>
                    </div>
                    <v-divider></v-divider>
                    <div class="project-description">
                        <p>Fun pet project demonstrates famous sorting algorithms</p>
                    </div>
                </div>
            </v-col>
            <v-col align="center" justify="center">
                <div class="project">
                    <div>
                        <div id="resume" class="project-icon" @click="openPage('/resume')">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 135.46667 135.46667">
                                <g style="display:inline">
                                    <ellipse
                                            fill="#cccccc"
                                            id="path839"
                                            cx="67.733337"
                                            cy="67.73333"
                                            rx="66.005371"
                                            ry="66.005363" />
                                    <circle
                                            r="59.407486"
                                            cy="67.733337"
                                            cx="67.733337"
                                            id="path840"
                                            fill="#121212" />
                                    <path
                                            fill="#69696a"
                                            d="M 53.088074,45.80648 H 31.46772 L 67.501647,109.53744 79.032504,91.010994 71.825718,78.413011 h -7.92746 L 71.105043,91.010994 68.222324,93.975217 56.691472,73.966666 H 68.943005 L 65.339611,68.038204 H 53.808754 L 45.881295,54.699169 h 4.324067 l 5.044749,8.892692 h 7.927467 z"
                                            id="path850"/>
                                    <path
                                            fill="#69696a"
                                            d="m 82.635897,45.80648 -10.810179,17.785381 13.692894,-2e-6 -5.04475,8.892689 -2.882716,-4.446347 -7.927461,3e-6 11.530855,19.267505 23.06171,-41.499229 h -9.368814 l -6.486112,11.115854 h -4.324072 l 6.486107,-11.115857 z"
                                            id="path860"/>
                                    <path
                                            fill="#69696a"
                                            d="M 57.41215,45.80648 67.501647,63.591861 78.311827,45.80648 Z"
                                            id="path858"/>
                                </g>
                            </svg>
                        </div>
                        <div class="project-title"><h4>Resume</h4></div>
                    </div>
                    <v-divider></v-divider>
                    <div class="project-description">
                        <p>This website or progressive web application</p>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <div class="description">
                    <p style="text-indent: 25px;">
                        For more information about projects press
                        <v-btn class="ma-2" tile outlined x-small color="#e65100" @click="openPage('/projects')">Projects</v-btn>
                    </p>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <div style="height:20px;"><p> </p></div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: "AboutMe",
        methods:{
            openPage(to){
                for(let index in this.links){
                    this.$store.dispatch('setLinkIsActive', {address: this.links[index].to, value: this.links[index].to === to})
                }
                // eslint-disable-next-line no-unused-vars
                this.$router.push(to).catch(err => {})
            }
        },
        computed:{
            links(){
                return this.$store.getters.getAvailableLinks;
            },
        },
    }
</script>

<style scoped>
    #resume:hover a{
        color: #e65100;
    }
    #resume:hover :nth-child(1) :nth-child(1) :nth-child(3), #resume:hover :nth-child(1) :nth-child(1) :nth-child(4),
    #resume:hover :nth-child(1) :nth-child(1) :nth-child(5){
        fill:#e65100;
    }
    #elegant-project:hover :nth-child(1) :nth-child(1) :nth-child(4), #elegant-project:hover :nth-child(1) :nth-child(1) :nth-child(5),
    #elegant-project:hover :nth-child(1) :nth-child(1) :nth-child(6), #elegant-project:hover :nth-child(1) :nth-child(1) :nth-child(1){
        fill:#000000;
    }
    #elegant-project:hover :nth-child(1) :nth-child(1) :nth-child(3){
        fill:#e65100
    }
    #pet-project:hover :nth-child(1) :nth-child(1), #resume:hover :nth-child(1) :nth-child(1) :nth-child(2){
        fill:#000000;
    }
    #pet-project:hover :nth-child(1) :nth-child(2) :nth-child(1), #pet-project:hover :nth-child(1) :nth-child(2) :nth-child(2){
        fill:#e65100;
    }

    #resume:hover ~ .project-title h4, #elegant-project:hover ~ .project-title h4, #pet-project:hover ~ .project-title h4{
        color: #e65100;
    }
    .v-application a {
        color: #ffffff;
    }
    a {
        text-decoration: none;
        color: #ffffff;
        text-align: center;
    }
    a:hover {
        text-decoration:none;
        cursor:pointer;
        color: #e65100;
    }
    svg{
        cursor: pointer;
    }
    svg:hover #vuetify :nth-child(1){
        fill:#1697f6;
    }
    svg:hover #vuetify :nth-child(2){
        fill:#7bc6ff;
    }
    svg:hover #vuetify :nth-child(3){
        fill:#aeddff;
    }
    svg:hover #vue :nth-child(1) :nth-child(1){
        fill:#41b883;
    }
    svg:hover #vue :nth-child(2) :nth-child(1){
        fill:#34495e;
    }

    svg:hover #javascript :nth-child(1) {
        fill:#d4b830;
    }
    svg:hover #javascript :nth-child(2) {
        fill:#fdd83c;
    }
    svg:hover #javascript :nth-child(3), svg:hover #javascript :nth-child(4), svg:hover #css :nth-child(3), svg:hover #css :nth-child(4), svg:hover #css :nth-child(5),
    svg:hover #html :nth-child(3), svg:hover #html :nth-child(4), svg:hover #html :nth-child(5), svg:hover #html :nth-child(6),
    svg:hover #php :nth-child(3) :nth-child(1), svg:hover #php :nth-child(5) :nth-child(1), svg:hover #php :nth-child(7) :nth-child(1){
        fill: #ffffff;
    }
    svg:hover #css :nth-child(1){
        fill: #264de4
    }
    svg:hover #css :nth-child(2){
        fill: #2965f1
    }
    svg:hover #html :nth-child(1){
        fill: #e44d26
    }
    svg:hover #html :nth-child(2){
        fill: #f16529
    }

    svg:hover #mysql :nth-child(1){
        fill: #00678c
    }
    svg:hover #mysql :nth-child(2){
        fill: #ce8b2c
    }
    svg:hover #php :nth-child(1) :nth-child(1){
        fill: #777bb3
    }
    svg:hover #php :nth-child(2) :nth-child(1), svg:hover #php :nth-child(4) :nth-child(1), svg:hover #php :nth-child(6) :nth-child(1){
        fill:#000000
    }
    svg:hover #java :nth-child(1), svg:hover #java :nth-child(2), svg:hover #java :nth-child(4),
    svg:hover #java :nth-child(5), svg:hover #java :nth-child(6), svg:hover #java :nth-child(8){
        fill: #5382a1
    }
    svg:hover #java :nth-child(3), svg:hover #java :nth-child(7){
        fill: #e76f00
    }
    h1 {
        margin-block-start: 0;
        margin-block-end: 0;
    }
    p{
        margin-bottom: 0!important;
    }
    .entry-header {
        margin-top: 20px;
    }
    .entry-title {
        font-weight: 900;
        color: #ffffff;
        line-height: normal;
        text-transform: lowercase;
        padding-right: 30px;
    }
    .about-me{
        margin-left: 20px;
        margin-right: 20px;
    }
    .subtitle{
        font-size: 18px;
        font-weight: 500;
        font-style: italic;
        line-height: 1.67;
        color: #e65100;
        display: flex;
    }
    .entry-subheader{
        margin-top: 40px;
    }
    .entry-subtitle{
        font-weight: 900;
        color: #ffffff;
        text-transform: lowercase;
        margin-bottom: 0;
    }
    .age{
        display: flex;
    }
    .age::after, .location::after{
        content: '/';
        font-size: 18px;
        font-weight: bold;
        font-style: italic;
        line-height: 1.67;
        color: #888888;
        opacity: 0.25;
        padding-left: 15px;
    }
    .location{
        margin-left: 15px;
        display: flex;
    }
    .current-status{
        margin-left: 15px;
    }
    .description{
        color: #888888;
        line-height: 1.73;

    }
    .technology-icon{
        width: 70px;
        height: 70px;
    }
    .project{

    }
    .project-icon{
        width: 50px;
        height: 50px;
        margin-bottom: 20px;
    }
    .project-title{
        height: 50px;
    }
    .project-description{
        margin-top: 10px;
        color: #69696a;
        font-size: 0.8rem;
    }
    @media only screen and (max-width: 599px) {
        h1 {
            font-size: 2rem;
        }
        h3 {
            font-size: 1rem;
        }
        .technology-icon {
            margin-left: -10px;
        }
    }
    @media only screen and (min-width: 600px) {
        h1 {
            font-size: 2rem;
        }
        h3 {
            font-size: 1rem;
        }
    }
    @media only screen and (min-width: 768px) {
        h1 {
            font-size: 3rem;
        }
        h3 {
            font-size: 2rem;
        }
    }
    @media only screen and (min-width: 992px) {
        h1 {
            font-size: 4rem;
        }
        h3 {
            font-size: 2rem;
        }
    }
</style>
